
export const MASK={
    'yyyy': {
        mask: '****',
        format: 'YYYY',
        separator: '',
        numeric: true,
    },
    'dd-mm-yyyy': {
        mask:'**-**-****',
        format:'DD-MM-YYYY',
        separator:'-',
        numeric:true
    },
    'dd/mm/yyyy':  {
        mask:'**/**/****',
        separator:'/',
        format:'DD/MM/YYYY',
        numeric:true
    },
    'dd.mm.yyyy': {
        mask:'**.**.****',
        separator:'.',
        format:'DD.MM.YYYY',
        numeric:true
    },
    'dd-mm-yyyy HH:mm': {
        mask:'**-**-**** **:**',
        separator:'-',
        format:'DD-MM-YYYY HH:mm',
        numeric:true
    },
    'dd-mmm-yyyy': {
        mask: '** *** ****',
        format: 'DD MMM YYYY',
        separator: ' ',
        numeric: false
    }
}